/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface MeanfulQtyLevels {
  id?: number;
  pairId?: number;
  tier?: MeanfulQtyLevels.TierEnum;
  lvl1?: number;
  lvl2?: number;
  lvl3?: number;
  lvl4?: number;
  lvl5?: number;
  lvl6?: number;
  lvl7?: number;
  lvl8?: number;
  lvl9?: number;
}
export namespace MeanfulQtyLevels {
  export const TierEnum = {
    Small: 'SMALL',
    Regular: 'REGULAR',
    Big: 'BIG',
  } as const;
  export type TierEnum = (typeof TierEnum)[keyof typeof TierEnum];
}
